<ng-container *ngIf="mode === 'recreate'">
  <h2 matDialogTitle>Konieczne przeliczenie koszyka</h2>

  <p>
    Szczegóły opłat uległy zmianie od czasu utworzenia koszyka. Przelicz koszyk, aby pobrać aktualne szczegóły opłaty.
  </p>

  <mat-dialog-actions align="start">
    <button color="accent" mat-raised-button matDialogClose="recreate">Przelicz koszyk</button>
  </mat-dialog-actions>
</ng-container>

<ng-container *ngIf="mode === 'cancel'">
  <h2 matDialogTitle>Wszystkie opłaty są już opłacone</h2>

  <p>
    Status opłaty zmienił się na <strong>Opłacona</strong> od&nbsp;czasu utworzenia koszyka. Aktualny status będzie
    widoczny w szczegółach opłaty.
  </p>

  <mat-dialog-actions align="start">
    <button color="accent" mat-raised-button matDialogClose="cancel">Opróżnij koszyk</button>
  </mat-dialog-actions>
</ng-container>
